import { createTheme } from "@mui/material";

//const themeSettings = require("./clinic/clinicSettings/defaultSettings/theme.json");
export enum ClinicColors {
  primary = "#5A52C3",
  secondary = "#8884A3",
  tertiary = "#E6E4FF",
  titles = "#1F0F55",
  textMain = "#243443",
  selectedBg = "#E4E2ED",
  mainBackground = "#F7F7F9",
  lightBackground = "#F5F5FF",
  lightBackground2 = "#E6E5F5",
  borders = "#E0E0E0",
  textBoxBg = "#F8F8F8",
}

const fontFamily = ["Inter", "-apple-system", "Segoe UI", "sans-serif"];

export const ClinicTheme = createTheme({
  palette: {
    primary: {
      main: ClinicColors.primary,
      light: ClinicColors.lightBackground,
    },
    secondary: {
      main: ClinicColors.secondary,
      light: ClinicColors.lightBackground2,
    },
    background: { default: "#FFFFFF" },
  },
  typography: {
    fontFamily: fontFamily.join(","),
    fontSize: 12,
  },
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          gap: 12,
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 0,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: ClinicColors.textMain,
          backgroundColor: "#FFFFFF",
          border: `1px solid #97979750`,
          padding: "10px",
          lineHeight: 1.2,
          margin: 0,
          "& .medium-tooltip": {
            fontSize: "0.8rem",
          },
          "& .bigger-tooltip": {
            fontSize: "0.9rem",
          },
          "& .multiline-tooltip": {
            whiteSpace: "pre-wrap",
          },
          "& .rtl-tooltip": {
            direction: "rtl",
            textAlign: "right",
            display: "block",
          },
          //boxShadow: ,
        },
        arrow: {
          color: "#FFFFFF",
          width: 20,
          height: 12,
          margin: "0 0 -12px 0 !important",
          "&:before": {
            border: `1px solid #97979750`,
          },
        },
        tooltipPlacementTop: {
          margin: "24px 0 6px 0 !important",
        },
      },
    },
    MuiSnackbar: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",
        },
      },
    },
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          backgroundColor: ClinicColors.primary,
          color: "#FFFFFF",
          justifyContent: "center",
        },
      },
    },
    MuiCssBaseline: {
      // styleOverrides: `
      //   // @font-face {
      //   //   font-family: 'Inter';
      //   //   font-style: normal;
      //   //   dont-display: swap;
      //   //   font-weight: 400;
      //   //   src: url('/fonts/Inter-Regular.woff2') format('woff2'),
      //   // }
      // `,
      styleOverrides: {
        root: { fontFamily: fontFamily.join(",") },
      },
    },
    MuiScopedCssBaseline: {
      styleOverrides: {
        root: {
          fontSize: "12px",
          lineHeight: 400,
        },
      },
    },
  },
});
